var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "adjustment-history" } },
    [
      _c("div", { staticClass: "row mt-4 mb-4 pl-3" }, [
        _c(
          "div",
          { staticClass: "col-md-3 col col-sm-6" },
          [
            _c("total-amount-view", {
              attrs: {
                amount: _vm._f("price")(_vm.data.amount),
                icon: "fa fa-usd-circle",
                "icon-color": "color-yellow-star",
                title: "Reembolso Solicitado:"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 col col-sm-6 mt-3 mt-md-0 mt-sm-3" },
          [
            _c("total-amount-view", {
              attrs: {
                amount: _vm._f("price")(_vm.data.adjustmentsTotal),
                icon: "fa fa-usd-circle",
                "icon-color": "color-primary-8",
                title: "Ajuste Realizado:"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "col-md-3 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3"
          },
          [
            _c("total-amount-view", {
              attrs: {
                amount: _vm._f("price")(_vm.data.amountToRefund),
                icon: "fa fa-usd-circle",
                "icon-color": "color-green",
                title: "Total a Reembolsar:"
              }
            })
          ],
          1
        )
      ]),
      _c("section-title", {
        attrs: { "has-line": true, title: "Ajustes Realizados" }
      }),
      _vm.adjustmentHistory.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con ajustes en sistema." }
          })
        : _vm._e(),
      _vm._l(_vm.adjustmentHistory, function(row) {
        return _c(
          "div",
          { key: row.id },
          [
            _c("result-row-adjustment", {
              attrs: { data: row, "status-id": _vm.data.statusId },
              on: {
                "on-delete": function($event) {
                  return _vm.$emit("on-delete-adjustment", $event)
                },
                "on-edit": function($event) {
                  return _vm.$emit("on-edit-adjustment", $event)
                }
              }
            })
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }